module.exports = __webpack_public_path__ + "img/foodpocket-demo.1dc8b6ce.jpeg";